document.addEventListener('DOMContentLoaded', () => {

    const collectionPage = document.querySelector('.page-template-template-collections')
    const collectionDetailPage = document.querySelector('.tax-pa_collection')
    const projectsPage = document.querySelector('.post-type-archive-project')
    const searchPage = document.querySelector('.search-results')

    if (collectionPage !== null || collectionDetailPage !== null || projectsPage !== null || searchPage !== null) {

        // Create filter overlay element
        const filterOverlay = document.createElement('div');
        filterOverlay.className = 'c-filter-overlay';
        filterOverlay.innerHTML = `
            <div class="c-filter-overlay__background"></div>
            <div class="c-filter-overlay__loader"></div>
        `;
        // Append to .js-filter instead of body to limit overlay to filter area only
        const filterContainer = document.querySelector('.js-filter');
        filterContainer.appendChild(filterOverlay);

        // Function to show the overlay
        function showFilterOverlay() {
            filterOverlay.classList.add('isActive');
        }

        const form = document.querySelector('.js-filter')
        const formMobile = document.querySelector('.js-filter-mobile')

        function setCommaFilters() {
            const commaFilters = document.querySelectorAll(".js-filter-comma")
            commaFilters.forEach(function (commaFilter) {
                const tax = commaFilter.dataset.tax
                const slice = Array.prototype.slice;
                commaFilter.value = slice.call(form.querySelectorAll('[data-tax="' + tax + '"]'))
                    .filter((input) => input.checked)
                    .map(input => input.value)
                    .join(',')
                if (commaFilter.value === '' || !commaFilter.value) {
                    commaFilter.remove()
                }
            })
        }

        function setCommaFiltersMobile() {
            const commaFilters = document.querySelectorAll(".js-filter-mobile .js-filter-comma")
            commaFilters.forEach(function (commaFilter) {
                const tax = commaFilter.dataset.tax
                const slice = Array.prototype.slice;
                commaFilter.value = slice.call(formMobile.querySelectorAll('[data-tax="' + tax + '"]'))
                    .filter((input) => input.checked)
                    .map(input => input.value)
                    .join(',')
                if (commaFilter.value === '' || !commaFilter.value) {
                    commaFilter.remove()
                }
            })
        }

        document.querySelectorAll('.js-filter .c-filter-item').forEach(function (filter) {
            filter.addEventListener('change', function () {
                setCommaFilters()
                showFilterOverlay()
                form.submit()
            })
        })

        document.querySelectorAll('.js-filter-mobile .c-filter-item').forEach(function (filter) {
            filter.addEventListener('change', function () {
                setCommaFiltersMobile()
            })
        })

        document.querySelector('.js-filter-mobile-apply')?.addEventListener('click', function () {
            showFilterOverlay()
            formMobile.submit()
        })

        document.querySelectorAll('.js-desktop-tag-filter').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault()

                document.querySelectorAll('.js-desktop-tag-filter').forEach(function (otherBtn) {
                    otherBtn.classList.remove('active')
                    const otherHiddenInputs = document.querySelectorAll('#filter-tag-' + otherBtn.dataset.id)
                    otherHiddenInputs.forEach((hiddenInput) => {
                        hiddenInput.checked = false
                    })
                })

                this.classList.toggle('active')

                const hiddenInputs = document.querySelectorAll('#filter-tag-' + btn.dataset.id);

                hiddenInputs.forEach((hiddenInput) => {
                    hiddenInput.checked = this.classList.contains('active')
                })

                setCommaFilters()
                showFilterOverlay()
                form.submit()
            })
        })

        document.querySelectorAll('.js-mobile-tag-filter').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault()

                const form = document.querySelector('.js-filter-mobile');
                const existing_input = document.querySelector('#product-mobile-tag-' + this.dataset.slug)

                if (this.classList.contains('active')) {
                    this.classList.remove('active')
                } else {
                    this.classList.add('active')
                }

                const hiddenInputs = document.querySelectorAll('#filter-tag-' + btn.dataset.id);

                hiddenInputs.forEach((hiddenInput) => {
                    hiddenInput.checked = !!this.classList.contains('active')
                })

                setCommaFiltersMobile()
            })
        })

        document.querySelectorAll('.js-active-filter-tag').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault()

                const form = document.querySelector('.js-filter');
                const existingTag = document.querySelector('#filter-tag-' + this.dataset.id)
                existingTag.removeAttribute('checked')

                setCommaFilters()
                showFilterOverlay()
                form.submit()

            })
        })

        document.querySelectorAll('.c-filter-item').forEach(function (filterItem) {
            const checkbox = filterItem.querySelector('input[type="checkbox"]')

            if (checkbox?.checked === true) {
                const filterListParent = filterItem.closest('.c-filter-list')
                filterListParent.classList.add('is-open')
            }
        })

    }

})
